import React from 'react';
import Iframe from 'react-iframe';
import axios from 'axios';

class PayPalAuth extends React.Component {

  state = { url: undefined };

  
  componentDidMount() {
    // window.addEventListener('paypalResponse', this.handleResponse);
    
    // axios.post('http://localhost:1368/bankfeed/transactions/paypal/approvalurl', { userId: '123', bookId: 'abc' })
    //   .then(response => {
    //       this.setState({ url: response.data });
    // });
    
  }
  componentWillUnmount() {
  //  window.removeEventListener('paypalResponse', this.handleResponse);
  }
  handleResponse = e => {
   // if(e.data === 'closeyodlee') this.props.closeYodlee();
  };

  render() {
    
   // if (!this.state.url) return <div>Loading</div>;
     
    return (
      <div>
        <Iframe
          url="https://www.sandbox.paypal.com/us/merchantsignup/partner/onboardingentry"
          width="750px"
          height="620px"
          id="myId"
          position="relative"
        />
      </div>
    );
  }
}

export default PayPalAuth;



// WEBPACK FOOTER //
// ./src/components/FeedManagment/PayPalAuth.js